import { isMockMode, post, simulateDelay } from "../api";

export const registerToNewOrg = (data, isAnonymous = false) => {
	if (isMockMode()) {
		const testData = { isValid: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/RegisterToNewOrg`, data, {
		successMessage: "Subscription successfully registered",
		isAnonymous,
	});
};
